// Marine Discovery — registret over arter man kan finde i appen.
//
// Registret indeholder KUN arter der faktisk kan findes. Fristelsen er at skrive alle tyve dyr ind
// med det samme og vise "3/20", men saa sender vi folk paa jagt efter sytten dyr der ikke er
// programmeret endnu. Naevneren vokser i stedet, efterhaanden som arter kommer til.
//
// Navn og tip ligger i i18n under species.<id>.name / .hint — tre sprog pr. art som alt andet.

export type Rarity = 'common' | 'rare' | 'legendary'

export interface Species {
  id: string
  rarity: Rarity
  /** SVG-sti(er) i et 24x24-felt, tegnet som resten af appens ikoner (stroke, currentColor). */
  paths: string[]
}

export const SPECIES: Species[] = [
  {
    id: 'pufferfish',
    rarity: 'common',
    paths: [
      'M12 4c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8Z',
      'M9.5 11h.01', 'M14.5 11h.01', 'M9.5 15c1.6 1 3.4 1 5 0',
      'M12 4V2', 'M12 22v-2', 'M4 12H2', 'M22 12h-2',
      'M6.3 6.3 4.9 4.9', 'M19.1 19.1l-1.4-1.4', 'M6.3 17.7l-1.4 1.4', 'M19.1 4.9l-1.4 1.4',
    ],
  },
  {
    id: 'crab',
    rarity: 'common',
    paths: [
      'M7 13a5 5 0 0 1 10 0v1H7v-1Z',
      'M9.5 11h.01', 'M14.5 11h.01',
      'M7 14l-3 3', 'M17 14l3 3', 'M9 15l-2 4', 'M15 15l2 4',
      'M6 9 4 6', 'M18 9l2-3',
    ],
  },
  {
    id: 'whiteshark',
    rarity: 'legendary',
    paths: [
      'M2 14c3-4 8-6 13-6 3 0 5 1 7 3-2 2-4 3-7 3-5 0-10-2-13-6Z',
      'M11 8V4l4 3', 'M20 17l2 3-4-1', 'M6 12.5h.01',
    ],
  },
]

export const SPECIES_IDS = SPECIES.map((s) => s.id)

export function speciesById(id: string): Species | undefined {
  return SPECIES.find((s) => s.id === id)
}
